import React from "react";
import { Box } from "Components/Base/Layout/Box";
import { useDisplayLearningActivityCardImage } from "lib/hocs/useLearningActivityCardState";
import Card from "./Card";
import {
  PROP_TYPE_PROGRAM_CONTENT,
  PROP_DEFAULT_PROGRAM_CONTENT,
} from "../../../../propTypes";

const ProgramCards = (props) => {
  const {
    steps,
    activityId,
    onRefresh,
    programParticipant,
    isPreview,
    isManager,
  } = props;
  const displayCardImage = useDisplayLearningActivityCardImage();

  return (
    <div className="program-cards flex flex-wrap">
      {steps.map((course, index) => {
        const courseWithIndex = { ...course, index };
        return (
          <Box key={course.courseId || index} my={4} mx={2}>
            <Card
              course={courseWithIndex}
              order={index}
              displayImage={displayCardImage}
              activityId={activityId}
              onRefresh={onRefresh}
              programParticipant={programParticipant}
              isPreview={isPreview}
              isManager={isManager}
            />
          </Box>
        );
      })}
    </div>
  );
};

ProgramCards.propTypes = {
  steps: PROP_TYPE_PROGRAM_CONTENT,
};

ProgramCards.defaultProps = {
  steps: PROP_DEFAULT_PROGRAM_CONTENT,
};

export default ProgramCards;
